/* eslint-disable react/prop-types */
import { Formik, Form } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import toast from "react-hot-toast";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Components & Services
import { JournalVoucher7Info } from "./info";
import { JournalVoucher7Service } from "services/journal-voucher-7";
import { getPrintTemplate } from "./components/printTemplate";

const today = new Date();

const initialValues = {
  unit: "",
  address: "",
  month: (today.getMonth() + 1).toString(),
  year: today.getFullYear().toString(),
  part1: {
    creditAccountLabels: [
      "152", "153", "154", "214", "241", "242", "334", "335",
      "338", "352", "356", "621", "622", "623", "627", "", ""
    ],
    otherVoucherLabels: ["NKCT số 1", "NKCT số 2", "NKCT...", "NKCT..."],
    rowsA: [
      { index: 1, debitAccountCode: "154", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 2, debitAccountCode: "241", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 3, debitAccountCode: "242", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 4, debitAccountCode: "335", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 5, debitAccountCode: "621", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 6, debitAccountCode: "622", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 7, debitAccountCode: "623", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 8, debitAccountCode: "627", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 9, debitAccountCode: "641", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 10, debitAccountCode: "642", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 11, debitAccountCode: "352", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 12, debitAccountCode: "....", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 }
    ],
    rowsB: [
      { index: 14, debitAccountCode: "152", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 15, debitAccountCode: "153", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 16, debitAccountCode: "155", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 17, debitAccountCode: "157", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 18, debitAccountCode: "632", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 19, debitAccountCode: "241", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 20, debitAccountCode: "111", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 21, debitAccountCode: "112", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 22, debitAccountCode: "131", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 },
      { index: 23, debitAccountCode: "...", creditValues: Array(17).fill(0), subTotalCredit: 0, otherVoucherValues: Array(4).fill(0), totalCost: 0 }
    ],
    totals: {
      creditValues: Array(17).fill(0),
      subTotalCredit: 0,
      otherVoucherValues: Array(4).fill(0),
      totalCost: 0
    }
  },
  part2: {
    rows: [
      { index: 1, accountName: "TK 154", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 2, accountName: "TK 242", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 3, accountName: "TK 335", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 4, accountName: "TK 621", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 5, accountName: "TK 622", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 6, accountName: "TK 623", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 7, accountName: "TK 627", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 8, accountName: "TK 641", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 9, accountName: "TK 642", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 10, accountName: "TK 241", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 },
      { index: 11, accountName: "TK 632", elementValues: Array(5).fill(0), subTotal: 0, internalTurnover: 0, totalCost: 0 }
    ],
    totals: {
      elementValues: Array(5).fill(0),
      subTotal: 0,
      internalTurnover: 0,
      totalCost: 0,
      accumulatedValues: Array(5).fill(0),
      accumulatedSubTotal: 0,
      accumulatedInternalTurnover: 0,
      accumulatedTotalCost: 0
    }
  },
  part3: {
    columnLabels: [
      "Dịch vụ của các phân xưởng cung cấp lẫn cho nhau TK 154", 
      "Chi phí nguyên liệu, vật liệu trực tiếp TK 621", 
      "Chi phí nhân công trực tiếp TK 622",
      "Chi phí sử dụng máy thi công TK 623", 
      "Chi phí sản xuất chung TK 627", 
      "Chi phí trả trước TK 242",
      "Chi phí phải trả TK 335", 
      "...", 
      "Dự phòng phải trả TK 352"
    ],
    rows: [
      { index: 1, accountName: "TK 154", detailValues: Array(9).fill(0), total: 0 },
      { index: 2, accountName: "TK 621", detailValues: Array(9).fill(0), total: 0 },
      { index: 3, accountName: "TK 622", detailValues: Array(9).fill(0), total: 0 },
      { index: 4, accountName: "TK 623", detailValues: Array(9).fill(0), total: 0 },
      { index: 5, accountName: "TK 627", detailValues: Array(9).fill(0), total: 0 },
      { index: 6, accountName: "TK 242", detailValues: Array(9).fill(0), total: 0 },
      { index: 7, accountName: "TK 335", detailValues: Array(9).fill(0), total: 0 },
      { index: 8, accountName: "TK 641", detailValues: Array(9).fill(0), total: 0 },
      { index: 9, accountName: "TK 642", detailValues: Array(9).fill(0), total: 0 },
      { index: 10, accountName: "TK 241", detailValues: Array(9).fill(0), total: 0 },
      { index: 11, accountName: "TK 352", detailValues: Array(9).fill(0), total: 0 }
    ],
    grandTotal: 0,
    columnTotals: Array(9).fill(0)
  },
  recordedToLedgerDay: "",
  recordedToLedgerMonth: "",
  recordedToLedgerYear: "",
  reportDate: "",
  ledgerClerk: "",
  chiefAccountant: "",
  legalRepresentative: "",
  signingDay: today.getDate().toString(),
  signingMonth: (today.getMonth() + 1).toString(),
  signingYear: today.getFullYear().toString(),
};

function JournalVoucher7Detail() {
  const { id } = useParams();
  const location = useLocation();
  const containView = location.pathname?.includes("/view");
  const navigation = useNavigate();
  const [formInitials, setFormInitials] = useState(initialValues);

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const response = await JournalVoucher7Service.getById(id);
          const apiData = response.data || response;

          // Parse reportDate
          let sDay = initialValues.signingDay;
          let sMonth = initialValues.signingMonth;
          let sYear = initialValues.signingYear;
          if (apiData.reportDate && apiData.reportDate.includes("/")) {
            const parts = apiData.reportDate.split("/");
            if (parts.length === 3) {
              [sDay, sMonth, sYear] = parts;
            }
          }

          setFormInitials({
            ...apiData,
            signingDay: sDay,
            signingMonth: sMonth,
            signingYear: sYear,
          });
        } catch (error) {
          console.error("Lỗi load S04a7-DN:", error);
          toast.error("Không thể tải dữ liệu");
        }
      })();
    }
  }, [id]);

  const handleBack = () => navigation("/templates/journal-voucher-7");

  const submitForm = async (fValues) => {
    try {
      const num = (v) => (v && v !== "" && !isNaN(v) ? Number(v) : 0);

      const mapperPart1 = (rows) => (rows || []).map(r => ({
        ...r,
        creditValues: (r.creditValues || []).map(num),
        otherVoucherValues: (r.otherVoucherValues || []).map(num),
        subTotalCredit: num(r.subTotalCredit),
        totalCost: num(r.totalCost)
      }));

      const payload = {
        ...fValues,
        part1: {
          ...fValues.part1,
          rowsA: mapperPart1(fValues.part1.rowsA),
          rowsB: mapperPart1(fValues.part1.rowsB),
          totals: {
            ...fValues.part1.totals,
            creditValues: (fValues.part1.totals?.creditValues || []).map(num),
            otherVoucherValues: (fValues.part1.totals?.otherVoucherValues || []).map(num)
          }
        },
        part2: {
          ...fValues.part2,
          rows: (fValues.part2.rows || []).map(r => ({
            ...r,
            elementValues: (r.elementValues || []).map(num),
            subTotal: num(r.subTotal),
            internalTurnover: num(r.internalTurnover),
            totalCost: num(r.totalCost)
          })),
          totals: {
            ...fValues.part2.totals,
            elementValues: (fValues.part2.totals?.elementValues || []).map(num),
            accumulatedValues: (fValues.part2.totals?.accumulatedValues || []).map(num)
          }
        },
        part3: {
          ...fValues.part3,
          rows: (fValues.part3.rows || []).map(r => ({
            ...r,
            detailValues: (r.detailValues || []).map(num),
            total: num(r.total)
          })),
          columnTotals: (fValues.part3.columnTotals || []).map(num),
          grandTotal: num(fValues.part3.grandTotal)
        },
        reportDate: `${fValues.signingDay.padStart(2, "0")}/${fValues.signingMonth.padStart(2, "0")}/${fValues.signingYear}`
      };

      if (!id) {
        await JournalVoucher7Service.create(payload);
        toast.success("Tạo nhật ký thành công!");
        navigation("/templates/journal-voucher-7");
      } else {
        await JournalVoucher7Service.update(id, payload);
        toast.success("Cập nhật thành công!");
      }
    } catch (error) {
      console.error("Lỗi lưu:", error);
      toast.error(error?.response?.data?.message || "Lưu thất bại!");
    }
  };

  const handlePrint = (pValues) => {
    const html = getPrintTemplate(pValues);
    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>In Nhật ký chứng từ số 7 S04a7-DN</title>
          <style>@media print { @page { size: A4 landscape; margin: 1cm; } }</style>
        </head>
        <body onload="setTimeout(() => [window.print(), window.close()], 500)">${html}</body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} mb={10}>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Formik initialValues={formInitials} enableReinitialize onSubmit={submitForm}>
              {({ values, isSubmitting, setFieldValue }) => (
                <Form autoComplete="off">
                  <Card>
                    <SoftBox p={0}>
                      <JournalVoucher7Info formData={{ values, setFieldValue, containView }} />
                      <SoftBox p={3} display="flex" justifyContent="space-between" mt={2}>
                        <SoftButton variant="gradient" color="light" onClick={handleBack}>Trở về</SoftButton>
                        <SoftBox display="flex" gap={2}>
                          {containView ? (
                            <SoftButton variant="gradient" color="success" onClick={() => handlePrint(values)}>In Nhật ký S04a7-DN</SoftButton>
                          ) : (
                            <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">{id ? "Lưu" : "Tạo mới"}</SoftButton>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default JournalVoucher7Detail;
